import { MAX_ABSOLUTE_VALUE, MAX_IMAGE_SIZE_IN_MB } from '@app/_helpers/constants';
import { PRODUCT_TYPE } from './modules/strategy-form/strategy.enums';
import { ActionNames } from '@app/modules/trading/modules/create-with-ai/chat.constants';

export const NO_BACKTEST_SELECTED_MESSAGE = 'Please Select a Backtest Strategy to be deployed/downloaded';
export const STOP_ALL_CONFIRMATION = 'Are you sure you want to stop all running strategies?'
export const CONFIRM_LOGOUT = 'Are you sure you want to log out?'
export const CONFIRM_ALL_SESSION_LOGOUT = 'Are you sure you want to log out all sessions?'
export const TERMINATE_INTRADAY_ON_LOGOUT = 'This action will undeploy the running intraday strategy(s). Are you sure you want to proceed?';
export const TERMINATE_CARRYFORWARD_ON_LOGOUT = 'This action will undeploy the running carryforward strategy(s). Are you sure you want to proceed?';
export const TERMINATE_ALL_ON_LOGOUT = 'This action will undeploy the running intraday and carryforward strategy(s). Are you sure you want to proceed?';
export const LOADING_MESSAGE = 'The action is being processed.';
export const LOADING_TIMEOUT_MESSAGE = 'Strategies could not termimate. Do you still want to logout?';
export const PAUSE_CARRYFORWARD_ON_LOGOUT = 'This action will pause the running Carryforward strategy(s). Are you sure you want to proceed?';
export const TERMINATE_INTRADAY_AND_PAUSE_CF = `This action will undeploy the Intraday strategy(s) and pause the Carryforward strategy(s). Are you sure you want to proceed?`;
export const SHARE_DIALOG_CLOSE_MESSAGE = `All selected clients will be removed. Do you want to proceed?`;
export const ALLOW_MARKET_CHANGE = `Switching will reset the strategy data. Do you want to proceed?`
export const ALLOW_UNDERLYING_CHANGE = `Changing Underlying will reset the Advanced Entry/Exit Conditions of the current strategy. Do you want to proceed?`;
export const AUTO_DEPLOY_TOOLTIP = `Auto Deployment Enabled`;
export const NO_MODIFICATIONS_AFTER_TERMINATION = `Runtime modifications are not allowed. The Strategy is already terminated.`;
export const SAVE_SETTINGS_TOOLTIP = 'Save to keep these settings for all sessions.';

export const TERMINATE_ALL_INTRADAY_OR_LOGOUT = "You can either <b>Terminate all</b> deployed Intraday strategies and log out, or just <b>Log out</b> while keeping your strategies running."
export const TERMINATE_ALL_CARRYFORWARD_OR_LOGOUT = "You can either <b>Terminate all</b> deployed Carryforward strategies and log out, or just <b>Log out</b> while keeping your strategies running."
export const TERMINATE_ALL_STRATEGIES_OR_LOGOUT = "You can either <b>Terminate all</b> the strategies and log out, or just <b>Log out</b> while keeping your strategies running."
export const TERMINATE_INTRADAY_AND_PAUSE_CF_OR_LOGOUT = "You can either <b>Terminate all</b> deployed Intraday strategies while keeping your Carryforward strategies paused and log out, or just <b>Log out</b> while keeping your strategies running."
export const PAUSE_ALL_CARRYFORWARD_OR_LOGOUT = "You can either <b>Pause all</b> deployed Carryforward strategies and log out, or just <b>Log out</b> while keeping your strategies running."

export function confirmStrategyStop(...args: string[]) {
    return `Are you sure you want to stop <b>${args.join(',')}</b> ?`;
}

export function alertAlgoTerminateMessage(msg: string) {
    if (!!msg) {
        return `${msg}, order placement for the algo has been disabled`;
    }
    return 'Order placement for the algo has been disabled';
}

export function symbolAditionLimit(limit: number) {
    return `Can't add more than ${limit} symbols`
}

export const CHANGES_SUCCESSFUL = 'Changes Made Successfully';

export const IMAGE_UPLOAD_SUCCESSFUL = 'Image Uploaded Successfully';
export const IMAGE_REMOVED_SUCCESSFUL = 'Image Removed Successfully';
export const IMAGE_FILE_SIZE_ALERT = `File size should be less than ${MAX_IMAGE_SIZE_IN_MB}MB`;
export const INVALID_IMAGE = 'Invalid image type.';
export const NO_RUNNING_STRATEGIES = 'No active algos exist.';
export const CONFIRM_STRATEGY_STOP_ALL = 'Are you sure you want to stop all strategies?';
export const CONFIRM_STRATEGY_STOP_SELECTED = 'Are you sure you want to stop the selected strategies?';
export const CONFIRM_STRATEGY_PAUSE = 'Are you sure you want to pause all the algos?';
export const CONFIRM_UNSUBSCRIBE_DEPLOYED_STRATEGY = 'Portfolio/strategy(s) is running. To unsubscribe, kindly undeploy it first.';
export const CONFIRM_UNSUBSCRIBE_UNDEPLOYED_STRATEGY = 'Please confirm to unsubscribe.';
export const CONFIRM_DEPLOY_STRATEGY = 'Are you sure you want to <strong>Deploy</strong> this portfolio?';
export const CONFIRM_MULTIPLE_DEPLOY_PORTFOLIOS = (num: number) => `Please click <strong>Ok</strong> to deploy ${num} selected portfolios.`;
export const CONFIRM_SUBSCRIBE_STRATEGY = 'Please click <strong>Ok</strong> to subscribe.';
export const PASSWORD_CHANGED_TEXT = 'Your password has been successfully<br> changed.';
export const STRATEGY_SAVED_SUCCESS = "Strategy Saved Successfully"
export const STRATEGY_NO_SYMBOL_SELECTED = 'Strategy needs atleast one symbol!';
export const STRATEGY_FORM_INVALID = 'Invalid Form, Please fill correct details!';

export const PANIC_CONTROL_PAUSE_TEXT = 'Running strategies will automatically stop in the next configured cycle or trading session, whichever is earlier.';
export const PANIC_CONTROL_STOP_TEXT = 'This will: <br>\
                                        1. Cancel all open orders <br>\
                                        2. Terminate all strategies <br>\
                                        3. Open positions needs to be managed manually'

export const DELETE_BROKER_WARNING = 'Deleting broker will terminate current running strategies for this broker. Do you want to proceed?';
export const BROKER_LOGOUT_WARNING = 'Logging out broker will terminate current running strategies, Do you want to proceed?';
export const BROKER_CHANGE_CLIENT_ID_WARNING = 'Changing broker username will terminate current running strategies, Do you want to proceed?';

export const SYMBOL_ADDITION_IN_UPDATE = 'Please remove current symbol to replace the symbol';
export const BROKER_LOGIN_SUCCESSFUL = 'Login Successfully!';
export const MANDATORY_FIELDS_MISSING = 'Mandatory Fields Missing';
export const MANDATORY_FIELDS_INVALID = 'Mandatory Fields Invalid';
export const DELETE_STRATEGY_MESSAGE = 'Are you sure you want to delete the strategy?';
export const DELETE_LEG_MESSAGE = 'Are you sure you want to delete the leg?';
export const UNDEPLOY_PORTFOLIO = 'Are you sure you want to <strong>Undeploy</strong> this portfolio?';
export const UNDEPLOY_MULTIPLE_PORTFOLIOS = (num: number) => `Are you sure you want to undeploy ${num} selected portfolios?`;
export const UNDEPLOY_STRATEGY = 'Are you sure you want to undeploy the strategy?';
export const TERMINATE_PORTFOLIO = 'Are you sure you want to terminate the portfolio?';
export const PAUSE_PORTFOLIO = 'Are you sure you want to pause the portfolio?';
export const RESUME_PORTFOLIO = 'Are you sure you want to resume the portfolio?';

export const MAX_LEGS_CREATED = 'You have reached the maximum number of legs. Please remove an existing leg to add a new dependent leg.';
export const NO_PRIMARY_LEG_CREATED = 'Atleast 1 main leg is required';
export const LEG_LOOP_DETECTED = 'Loop detected: Current Dependent leg settings are causing them to re-trigger endlessly. Please update the conditions to break the cycle.';
export const STG_LOOP_DETECTED = 'Loop detected: Current Dependent strategy settings are causing them to re-trigger endlessly. Please update the conditions to break the cycle.';
export const BACKTEST_ATM_MESSAGE = 'For the selected Expiry(s), the backtesting duration should be closer to the Expiry(s).';
export const BACKTEST_BASIC_MESSAGE = 'For the selected Expiry(s) and Strike(s), the backtesting duration should be closer to the Expiry(s).';

const extraNoteOnSquareOff = "<strong>Note:</strong> Please verify your positions on the broker's side before proceeding. If positions are already closed, this action might open a new unintended position.";

export const SQUAREOFF_POSITIONS = '<div>Do you want to square off all the open positions in this portfolio?</div>' + `<br/> <div>${extraNoteOnSquareOff}</div>`;
export const SQUAREOFF_POSITIONS_MULTIPLIE_PORTFOLIOS = (num: number) => `<div>Do you want to square off all the open positions in ${num} selected portfolios?</div>` + `<br/> <div>${extraNoteOnSquareOff}</div>`;
export const SQUAREOFF_POSITIONS_STRATEGY = '<div>Do you want to square off all the open positions in this strategy?</div>' + `<br/> <div>${extraNoteOnSquareOff}</div>`;

export const SQUAREOFF_ALL = "Square off All"

export const SQUAREOFF_SELECTED = "Square off Selected"

export const CANCEL_SQUAREOFF = 'Cancel Auto Square Off';

export function confirmPortfolioDelete(portfolioName: string, isDeployed: boolean, isPositionObjects?: boolean) {
    if (isDeployed || isPositionObjects) {
        return `<b>${portfolioName}</b> is running. To delete, kindly undeploy it first.`
    }
    return `Are you sure you want to delete "<b>${portfolioName}</b>"?`;
}

export const MAXIMUM_LOTS_ALLOWED = `Maximum lots allowed per symbol is ${MAX_ABSOLUTE_VALUE}`;

export const PAYOFF_CURVE_NOT_ALLOWED = 'Payoff curve not allowed in your plan';
export const MARGIN_CALC_NOT_ALLOWED = 'Margin calculator not allowed in your plan';
export const MARGIN_CALC_NOT_SUPPORTED_FOR_STRIKE = 'Margin calculation not supported for strike selection type price.'

export const PORTFOLIO_SUMMARY_0 = "You don't have any portfolios working for you.";
export const PORTFOLIO_SUMMARY_1 = "You've got 1 portfolio working for you.";
export const PORTFOLIO_SUMMARY_N = "Here's an overview of today's top portfolios."

export const DELETE_LAST_STRATEGY = "This will delete portfolio. Are you sure you want to delete?";
export const PLANS_DIALOG_TITLE = "Upgrade to premium plan to enjoy access to exclusive features!"
export const PLANS_PAGE_TITLE = "Simple & flexible pricing built or everyone";
export const CONNECT_BROKER_TO_DEPLOY_LIVE = "Denied! Please connect with your Broker - Shareindia to deploy live strategies."

export const CANCEL_TOOLTIP = "Subscription cancelled! Auto-renewal discontinued.";
export const CANCEL_PLAN_CONFIRMATION = "Are you sure you want to cancel your subscription?";

export const EMAIL_REGISTERED = "Email already registered and verified. Do you want to proceed to login ?";
export const MOBILE_REGISTERED = "Phone Number already registered and verified. Do you want to proceed to login ?";
export const EMAIL_PHONE_VERIFIED = "Email and Phone number already registered but not verified. Do you want to resend verification link ?";
export const PHONE_REGISTERED = "Phone number already registered";


export const VERIFYING_UPI = 'Verifying your UPI Id';

export const WAITING_TO_ACCEPT_MANDATE = 'Waiting for user to accept the payment Mandate';

export const SUBSCRIBING_TO_PLAN = 'Subscribing to your selected plan';

export const PLANS_CONFIRMATION = 'Do you wish to upgrade your plan to unlock these features?'

export const TEMP_PORTFOLIO_NOTE = "Above Strategy(s) will be deployed in a temporary portfolio, auto-deleted by end-of-day." +
    " You can change the default portfolio values on edit or save this portfolio from 'Created' section later."

export const ALLOCATION_TEXT = 'In case of plan upgradation, any remaining balance from your previous plan is adjusted in the new plan.'

export const UPGRADE_INFO_TOOLTIP = 'When you upgrade within the same plan frequency, your billing cycle remains unchanged.' +
 ' The charges shown are adjusted accordingly for the rest of your current period. For example, if you upgrade halfway through a month, the new plan applies for the remaining half, and charges are adjusted.'

export const PLAN_UNSUBSCRIBE = 'If you unsubscribe to any plan auto-renewal of plan would be stopped.'

export const DOWNGRADE_CONFIRMATION = 'Selected plan will come into effect from next billing cycle. Do you want to proceed?'

export const LOW_BALANCE = 'Balance is low you need to allocate margin';

export const SUFFICIENT_BALANCE = 'Balance is sufficient you can proceed further with the same';

export const ALGO_SPACE_MAPPING_REQUIRED = 'Algo space mapping is required before deploying to this broker.';

export const ALGO_SPACE_REQUIRED_SUBTEXT = 'Map an Algo Space to this connection to place orders.';

export const ACTIVE_ALGO_LIMIT_REACHED = 'Active Algo limit reached';

export const ALGO_SPACE_VM_DOWN = 'The selected algo space VM is currently unavailable. Please try again later.';

export const ALGO_SPACE_ONLY_ACTIVE_MAILABLE = 'Only active algo spaces can be mapped.';

export const ALGO_SPACE_EXPIRED = 'Algo Space expired';

export const ALGO_SPACE_PROVISIONING = 'This algo space is still provisioning and cannot be mapped yet.';

export const ALGO_SPACE_REMOVAL_BLOCKED_RUNNING_ALGOS = 'Cannot remove algo space mapping while algos are running on this broker connection.';

export const ALGO_SPACE_REQUIRED_FOR_LOGIN = 'Algo Space required';

export const ALGO_SPACE_MAPPING_FROZEN_WHILE_LOGGED_IN = 'Algo space mapping cannot be changed while the broker is logged in.';

export const ALGO_SPACE_MAX_MAPPING_REACHED = 'Maximum algo space mapping limit reached for this broker.';

export const LOGIN_ALGO_SPACE_SELECTION_REQUIRED = 'Select an algo space before logging in to this broker.';

export const LOGIN_SPACE_SETUP_SUBTEXT = 'Buy or assign now';

export const ALGO_SPACE_READY_TO_MAP = 'Algo Space ready to map';

export const CONFIRM_LINK_ACCOUNTS_1 = 'Broker account already linked with a different uTrade Algos account. Previously linked account will be unlinked and logged out. All running strategies will be terminated. Do you want to proceed?';

export const CONFIRM_LINK_ACCOUNTS_2 = 'The current uTrade Algos account is already linked with different Broker account. Previously linked account will be unlinked. Do you want to proceed?';

export const CONFIRM_LINK_ACCOUNTS_3 = 'Previously linked accounts will be unlinked for both users. Do you want to proceed?';

export const SUBSCRIBE_ERR_MESSAGE = 'Subscribing to uTrade Originals is not allowed as per plan';

export const BEYOND_MARKET_HOURS_MESSAGE = 'Unable to execute beyond market hours';

export const USER_LOCKED = 'User Locked. Reset your password to access the account.';

export const LEG_ENTRY_TEXT = 'In case of range on basis of time, strategy will start tracking high/low of premium or underlying and trigger the order post end time.<br><br>\
    In case of range on basis of value, if entry condition is high/low and the selected base breach the selected low or high value, entry will be taken.<br><br>\
    If entry condition is “in between” and selected base lies in range, entry will be taken.';

export const LEG_ENTRY_TEXT_EQUITY = ' In case of range on basis of time, strategy will start tracking high/low of price and trigger the order post end time. <br><br>\
In case of range on basis of value, if entry condition is high/low and the selected base breach the selected low or high value, entry will be taken. <br><br>\
If entry condition is “in between” and selected base lies in range, entry will be taken.'

export const SQUAREOFF_MESSAGE = 'Check deployed section to take further action.';

export const SQUAREOFF_DESCRIPTION = 'Go to Deployed Section';

export const UPGRADE_PLAN = 'Upgrade Plan';

export const ORDER_BOOK = 'Check Order Book';

export const ENABLE_FO = 'Click to activate F&O';

export const MAP_ACCOUNT = 'Click to map account';

export const ALL_SESSION_LOGGED_OUT = 'All active sessions are logged Out';

export const LOGGED_OUT = 'Successfully logged Out';

export const MARGIN_CALC_NOT_SUPPORTED = 'Margin calculation not supported for strike selection type price.';

export const LOGGED_IN_MSG = 'Logging In with currently active user.';

export const END_TIME_PASSED_ERROR = 'Execution failed as End/Square off Time passed';

export const ERROR_LOGIN_WITH_GOOGLE = 'Kindly set your password to access the account.';

export const PORTFOLIO_EXECUTED = 'Portfolio executed successfully';

export const PORTFOLIO_TERMINATE = 'Portfolio received termination request';

export const SYMBOL_NOT_FOUND = 'Symbol Not Found';

export const TOTAL_NET_PNL = 'Total Net PnL';

export const DAY_GROSS_PNL = 'Day\'s Gross PnL';

export const GLOBAL_EXIT_BREACH = 'Please change the Global Exit settings to deploy ';

export const GLOBAL_EXIT_NO_CHANGES = 'No changes made';

export const NOTE_SO_STRATEGY = '*NOTE: Both exit conditions pre-defined and those provided by the user will be taken into account. Strategy will take exit on whichever hits first.';

export const UNABLE_TO_DEPLOY_AS_SERVER_IS_DISCONNECTED = "Unable to deploy strategy as server is disconnected. Please try again after sometime."

export const PLANS_TAX_APPLICABLE = "*Prices are exclusive of all taxes"
export const AUTO_PAY_INFO = 'Enable Autopay for uninterrupted access with automatic subscription renewals.';

export const AUTO_PAY_INFO_UPI = 'Enable Autopay to proceed with UPI';

export const GLOBAL_EXIT_BUTTON = 'Go to global exit settings';

export const STRATEGY_NOT_BACKTESTED = 'Strategy is not Backtested yet';

export const BACKTEST_PENDING = 'Backtest is pending';

export const ADVANCE_PAYMENT_INFO = 'Advance payment already recieved for the next billing cycle';

export const CARRYFORWARD_PORTFOLIOS = 'To run portfolios today, the Carryforward portfolio must be resumed. Would you like to resume all connected brokers active portfolios';

export const CARRYFORWARD_PORTFOLIOS_BROKER_WISE = (num: number) => `You have ${num} Carry Forward portfolios in a paused state on this broker.
Do you want to resume the portfolios to activate them?`;

export const APPLE_SUBSCRIPTION_ACTIVE = 'Your Apple subscription is already active. Kindly cancel the existing subscription to purchase a plan at Web platform.';

export const AUTO_PAY_STATE = "Automatic subscription renewals.";

export const NOT_ALLOWED_IN_PLAN = 'Current Action is not allowed in your plan';

export function maxAlgosAlert(maxAlgos: number, isDowngraded: boolean) {
    if (isDowngraded) {
        return `Your upcoming plan allows deploying only ${maxAlgos} portfolios. Please undeploy additional portfolios, or upgrade your plan.`;
    }
    return `Your new plan allows deploying only ${maxAlgos} portfolios. Please undeploy additional portfolios, or upgrade your plan.`;
}

export const EXPIRIRING_PLAN_MAX_ALGO_ALERT = 'Your plan is expiring soon. Please subscribe to a plan for seamless trading or undeploy all portfolios.';

export const EXPIRED_PLAN_MAX_ALGO_ALERT = 'Your plan has expired. Please subscribe to a plan for seamless trading or undeploy all portfolios.';


export const CONFIRM_SHARE_PERMISSION = 'You are changing the user rights to share portfolios to others. Are you sure you want to proceed?';

export const OTP_VERIFIED = 'OTP Verified!';

export const OTP_INVALID = 'Invalid/Expired OTP!';

export const OTP_SENT = 'OTP sent successfully';

export const MAX_RESEND_ATTEMPTS_EXCEEDED = (maxResendAttempts: number) => `Maximum resend attempts (${maxResendAttempts}) exceeded. Please try again later.`;

export const FAILED_TO_SEND_OTP = 'Failed to send OTP. Please try again.';

export const MASK_PART = "******";

export const EMAIL_UPDATED = "Email updated successfully";
export const EXPIRED_PLAN_RESUME_ALERT = 'Your plan is expired. Please subscribe to a plan to deploy portfolios';

export const PLANS_REDIRECT_END_POINT = 'auth/callback/shareIndia/?postSiRedirectUrl='; // value to be appended to the url dynamically

export const PLANS_REDIRECTION_URl = 'trading/profile/user/plans';

export const DISABLE_DOWNGRADE = 'Since Autopay is OFF, downgrade request cannot be placed. Kindly wait till your current plan is valid.';

export const OFFLINE_MESSAGE = 'Request not processed. Please check your internet connection.';

/** API error payload `code` value returned when a service is in planned downtime. */
export const SERVICE_UNAVAILABLE_ERROR_CODE = 'SERVICE_UNAVAILABLE';

export const BROKER_NOT_AVAILABLE = 'BROKER_NOT_AVAILABLE';
export const BROKER_NOT_AVAILABLE_LEARN_MORE = 'Learn More';

export const UPLOAD_ERROR_MESSAGE = 'Error while uploading file.';

export const DOWNLOAD_ERROR_MESSAGE = 'Error while downloading file.';

export const MULTIPLE_FILES_ERROR = 'Multiple files are not allowed.';

export const INVALID_JSON_FILE = 'Invalid file type. Please upload a JSON file.';

export const FILE_SIZE_ERROR = 'File size should be less than 100 Kbs.';

export const WITHDRAWAL_MARGIN_FORMULA = `<b>Withdrawal margin Formula</b><br>Cash + Payin - Margin Utilised - Deduction - Blocked_Payout`;
export const AUTO_PAY_ALERT = `<img src="/assets/icons/warning.svg"/><h4>Disable Autopay</h4>
<p>Autopay ensures uninterrupted access to our services by automatically processing subscription renewals.</p>
<p>Are you sure you want to turn off autopay for your subscription?</p>`;

export const DISABLE_AUTO_PAY_ALERT = `<img src="/assets/images/alert-blue.svg"/>
<p>Autopay ensures uninterrupted access to our services by automatically processing subscription renewals.</p>
<p>Are you sure you want to turn off autopay for your subscription?</p>`;

export const ENABLE_AUTO_PAY_ALERT = `
<p>Autopay ensures uninterrupted access to our services by automatically processing subscription renewals.</p>
<p>Do you want to turn on autopay for your subscription?</p>`;

export const DOWNGRADE_ALERT = `<img src="/assets/icons/warning.svg"/><h4>Autopay is OFF</h4>
<p>The selected plan will not renew at the start of the next billing cycle because autopay is OFF.
To subscribe this plan, please repurchase it after your current plan plan billing cycle ends.</p>`

export const AUTOPAY_ENABLED = 'Autopay enabled! Enjoy uninterrupted access to our services with automatic renewals';

export const DISABLE_AUTOPAY = 'Upgrade to a paid plan to enable AutoPay for seamless payments';

export const ENABLE_RETAIN_MULTIPLIER_ALERT = `<h3>Enable Retain Multiplier</h3>
<p>This feature automatically retains your last used multiplier of portfolios for future deployments.</p>
<p>Do you want to enable this feature?</p>`;

export const DISABLE_RETAIN_MULTIPLIER_ALERT = `<h3>Disable Retain Multiplier</h3>
<p>This will stop retaining the last used multiplier of portfolios for future deployments.</p>
<p>Do you want to disable this feature?</p>`;

export const AUTO_PAY_DISABLED_ON_RESTRICTED_PLAN_SUBSCRIPTION =  (planName: string = 'This') => `${planName} Plan is a limited period offer. Autopay cannot be enabled for this plan.`;
export const AUTO_PAY_DISABLED_FOR_RESTRICTED_PLAN = (planName: string  = 'This') => `${planName} Plan is a limited period offer and has already been availed successfully. Autopay cannot be enabled for this plan.`;
export const RESTRICTED_PLAN_REDEEMED = (planName: string = 'This') =>  `${planName} Plan is a limited period offer and has already been availed successfully. Autopay cannot be enabled for this plan.`;

export const STRATEGY_LIMIT_EXHAUST = 'Portfolio strategy limit exhausted';

export const UNDEPLOY_PORTFOLIO_MESSAGE = 'Please undeploy the portfolio where the strategy needs to be copied.';

export const LIVE_SELECTED = 'The selected mode of deployment will activate the Auto Deployment functionality for the following days : '

export const LIVE_AUTO_NOT_SELECTED = 'The selected mode of deployment will deactivate the Auto Deployment functionality.<br>';

export const LIVE_AUTO_SELECTED = 'Portfolio will be deployed automatically, on the following days : ';

export function getNegativeFundString(appliedDiscount: number, actualDiscount: number) {
    return `A ${appliedDiscount}% discount coupon was applied, but the maximum allowed discount for this transaction is ${actualDiscount}%. Therefore, a ${actualDiscount}% discount has been given on your brokerage charges`;
}   

export const PROMOTION_PLAN_CAPTION = '*Limited period one-time subscribable offer';

export const EXCHANGE_CHANGE = 'Please define your legs again'

export const PRODUCT_TYPE_NOT_ALLOWED = (productType: PRODUCT_TYPE) => `${productType} portfolios not allowed. Contact administration.`

export function getAutoDeploymentChangeMessage(day: string) {
    return `Current Auto deployment cycle will end on <br/> ${day}, updated settings will be effective for all users from the next cycle.`;
}

export const HELP_SECTION_STRINGS = {
    USER_MANUAL: `Get detailed insights on how to effectively use the product.`,
    VIDEOS: `Tutorials that make algo trading easier.`,
    FAQS: `Check out frequently asked questions about Algo Trading`,
    WHATSAPP: `Contact us on WhatsApp`,
    CALLUS: `Call us on our Toll Number`,
    EMAILUS: `Write us an email at`
}
export const COUPON_FOR_ONLY_NEW_USERS = 'This coupon is limited to new users only.';

export const COUPON_UTM_MISMATCH = 'This coupon code is only valid for users who signed up with a specific signup link.';

export const INVALID_COUPON_PLACEHOLDER = 'Invalid Coupon.';

export const PNL_DISCLAIMER = 'Additional charges such as Brokerage, STT, GST, Stamp duties, SEBI, and transaction charges, are not included in the PnL figures shown.';

export const CAPTCHA_FAILED = "Please complete the CAPTCHA verification to proceed.";

export const LOGOUT_TYPE_MESSAGE = "Please select how you'd like to logout from the application:";

export const CONFIRM_EDIT_MULTIPLIER = (val)=>{
    return `Current Multiplier is x${val}. Reducing the multiplier will update the portfolio and square off any excess quantities, if already traded. 
Are you sure you want to proceed?`
};

export const CONFIRM_REDUCE_MULTIPLIER = (val)=>{
    return `Current Multiplier is x${val}. Reducing the multiplier will resume the portfolio and square off any excess quantities if already traded.
Are you sure you want to proceed?`
};

export const LIMIT_BREACHED_LOGOUT_MESSAGE = 'Previous session was logged out due to exceeding active session limit.';

export const SLIPPAGE_TOOLTIP_TEXT = "Slippage refers to the difference between the price you expected to trade (buy or sell) at and the price you actually got. By adding slippage, you can gain a more realistic understanding of potential execution prices under various market conditions";

export const CONFIRM_EDIT_PORTFOLIO = 'You are editing a deployed portfolio. These changes will only apply to the current running instance and will not affect the original strategy. \n\n Are you sure you want to proceed?';

export const CONFIRM_PORTFOLIO_EDIT_EXITED = 'The portfolio is already terminated.';

export const OPERATOR_CLIENT_VALIDATION_FAILED = "Validation failed: Please ensure all inputs meet the required character length."

export const OPERATOR_MULTIPLIER_UPDATE_NOTE = "Note: Only strategies with a non-zero multiplier will be selected and their existing multipliers will be overwritten. Please review the configurations carefully before proceeding."

export const CSV_COLUMN_MISSING = 'Error: Column missing in csv data';

export const INCORRECT_FILE_FORMAT = 'Error: Incorrect file format';

export const FAILED_CSV_IMPORT = (numOfRows: number) => `Error: Unable to add ${numOfRows} rows`;
export const OPERATOR_MAPPING_DIALOG_MESSAGE = "Mapping this client to the Executive will allow the Executive to take actions on behalf of the client. \n\n Are you sure you want to proceed?" 
export const MULTI_UCC_CONFLICT_MESSAGE = "This UCC has previously accessed the free plan. If you proceed with linking, the current free plan will expire, and no free extension will be available."

export const COLLATERAL_CASH = "Collateral (Cash) refers to the margin received from pledged liquid bees ETFs, liquid mutual funds and offline cash transactions."

export const COLLATERAL_NON_CASH = "Collateral(Non-Cash) refers to the margin received against pledged stocks, ETFs, and mutual funds."

export const USER_ID_COPY_SUCCESS = "User ID copied to clipboard";

export const API_KEY_COPY_SUCCESS = "Copied to clipboard";

export const CARRYFORWARD_STRATEGY_ERROR = 'Portfolio with Product as Carryforward cannot be deployed directly. Please save the portfolio first before proceeding with deployment.';

export const MULTI_DEPLOY_DISCLAIMER = `
<div><strong>Disclaimer</strong> - This allocation is AI-generated based on historical performance and backtesting results. It is not financial advice and does not guarantee future returns.</div>
<br>
<div>Past performance is not indicative of future results. Please consult with a qualified financial advisor before making any investment or trading decisions.</div>
<div>Algo trading is subject to market risks, technology failures, etc. Please trade using algorithms diligently.</div>
`;

export const CONFIRM_OPERATOR_MAPPING = (clientMapping: Record<string, string>) => `
<div>
    The following clients are already assigned to a different executive. Saving these changes will unmap them from their current executive and reassign them to the selected executive.
</div>
<br>
<strong>
    Clients currently mapped to another executive:
</strong>
<div>
    ${Object.keys(clientMapping).map(client => `<div>${client} -> ${clientMapping[client]}</div>`).join('')}
</div>
<br>
<div>
    Are you sure you want to proceed?
</div>
`;
export const MODIFY_PRE_MW_ERROR = 'Can\'t modify a predefined marketwatch. Please create a new marketwatch.';
export const MARKET_WATCH_ORDER_SAVED = 'Market Watch Changes Saved';

export const MULTIPLIER_VALUE_EXCEEDS_ALLOWED_LIMIT = 'Multiplier value exceeds allowed limit.';

export const MULTIPLIER_VALUE_MUST_BE_GREATER_THAN_0 = 'Please enter a valid multiplier value.';


export const DEPLOY_DIALOG_TEXT = '**Algo trading in index derivative markets are subject to market risk. Please remember that past performance may not be indicative of future results.';

export const FREE_PLAN_VALIDITY = '30 days validity';

export const ACCOUNT_INACTIVE_BROKER_MESSAGE = 'Account is Inactive. Please contact your broker.';

export const ERROR_CALLING_RPC = 'error calling RPC';
export const PLANS_HIDDEN_MESSAGE = 'Plans Module is currently unavailable.';

export const POSITION_OPEN_CLOSE_AT_BROKER_PNL_UNAVAILABLE =
  'Position open — close at broker terminal. PnL unavailable as exit was not via uTrade Algos.';

export const PNL_LAST_KNOWN_POSITION_VERIFY_AT_BROKER =
  'PnL based on last known position when algo was stopped. Verify at broker terminal.';

export const NO_EMAIL_LINKED_TO_APPLE_ACCOUNT = `We couldn't retrieve your email from Apple. Please sign in using your phone number, Google account, or email instead.`;

export const NO_EMAIL_LINKED_TO_GOOGLE_ACCOUNT = `We couldn't retrieve your email from Google. Please sign in using your phone number, Apple account, or email instead.`;

export const BILLING_PORTAL_ERROR = "We couldn't redirect you to the billing portal at this time. Please try again.";

export const REGULATORY_DISCLAIMER_TEXT = (deployed: boolean) =>  `Please analyze the risks carefully before proceeding. Click on Proceed to ${deployed ? 'Resume' : 'Deploy'}`;
export const UNABLE_TO_VERIFY_DEPLOYMENT_SETTINGS = "Unable to verify deployment settings. Please try again.";
